import React from "react";

export const LogoOk = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>(function LogoOk(props, ref) {
	return (
		<svg ref={ref} fill="#fff" {...props}>
			<use xlinkHref="#icon-logo_ok"></use>
		</svg>
	);
});
